import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ExpenseCodeListLayer from "../components/ExpenseCodeListLayer";

const ExpenseCodePage = () => {
  return (
    <>
      <MasterLayout pageTitle="Expense Codes">
        <ExpenseCodeListLayer />
      </MasterLayout>
    </>
  );
};

export default ExpenseCodePage;
